import { defineMessages } from 'react-intl';

export default defineMessages({
  female: 'Żeńska',
  male: 'Męska',
});
